/**
 * The marker a refused topic subscription announces itself with.
 *
 * The browser only ever asks for a topic on a screen the person may open, so the server refusing
 * one is a defect in OUR OWN client rather than an expected outcome - and it is a silent defect by
 * nature, because nothing breaks: the screen renders, the list loads, and only the live updates
 * that never arrive are missing. Rule 4 of
 * `documentation/ui-qa/notifications/sse-topic-authorisation-acceptance.md` makes it loud instead,
 * so a journey or a unit test finds it rather than a person waiting on a stale screen (D-132).
 *
 * `[SSE] REFUSED TOPIC` is plain ASCII deliberately, so a Playwright console assertion, CI output
 * and `grep` can all find it, and it cannot occur in ordinary product logging - which is what lets
 * one shared fixture police every screen. The same reasoning as `MISSING_TERM_SENTINEL` in
 * `src/language/term-resolution.ts`.
 *
 * ITS OWN MODULE, not a member of `sse-client.ts`, because the Playwright suite's guard must match
 * on this exact string and importing it from the client would pull the API factory, axios and the
 * `EventSource` machinery into the Playwright node process for the sake of one constant. The e2e
 * suite already imports leaf modules out of `src/` (terms, label constants, facet definitions) and
 * this is one.
 */
export const REFUSED_TOPIC_SENTINEL = '[SSE] REFUSED TOPIC';
